/**
 * Lifts a password-reset token out of the URL before anything else can read it.
 *
 * PostHog is initialised with `capture_pageview: true` and reports
 * `$current_url` including the query string, and Sentry attaches the URL to
 * every event — both start in main.tsx before React mounts. A scrub inside a
 * component would lose that race, so this must be called at the very top of
 * main.tsx, above initSentry()/initPostHog().
 *
 * The token is kept in a module variable rather than storage: it is a
 * credential, it is needed exactly once, and nothing should outlive the tab.
 */
let captured: string | null = null;

export function captureResetToken(): void {
  if (typeof window === 'undefined') return;

  const url = new URL(window.location.href);
  const token = url.searchParams.get('token');
  if (!token) return;

  captured = token;

  // Strip it from the address bar, history entry and any future Referer.
  url.searchParams.delete('token');
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}

/** The token from the link, if this page was opened from one. */
export function getResetToken(): string | null {
  return captured;
}

/** Drop it once redeemed, so a back-navigation cannot replay it. */
export function clearResetToken(): void {
  captured = null;
}
